import { render, staticRenderFns } from "./StartupsIndex.vue?vue&type=template&id=c2e4e3aa&scoped=true"
import script from "./StartupsIndex.vue?vue&type=script&lang=js"
export * from "./StartupsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e4e3aa",
  null
  
)

export default component.exports